/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="bcm-container thankyou-page-wrapper">
    <b-row no-gutters class="mt-4_1">
      <div class="col border border-secondary">
        <div class="d-flex flex-column text-center my-auto pt-5 pb-5">
          <h3 v-t="'checkout.thanks_buy'" class="text-uppercase"></h3>
          <div class="my-3">
            <p v-t="'checkout.order_confirmed'" class="mb-0"></p>
            <p v-t="'checkout.email_thanks'"></p>
          </div>
          <router-link class="btn mx-auto"  v-t="'backHomePage'" :to="{ name: 'home' }"></router-link>
        </div>
      </div>
    </b-row>
    <my-single-order :orderId="$route.query.order_id" class="mt-4_1" styleMode="thankyou"/>
    <div class="text-center">
      <router-link class="btn mt-4_1"  v-t="'backHomePage'" :to="{ name: 'home' }"></router-link>
    </div>
  </section>
</template>

<script>
import MySingleOrder from 'theme/pages/MyAccount/MySingleOrder'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      newUser: state => state.user.newUser,
      currentOrder: state => state.orders.currentOrder
    })
  },
  beforeMount () {
    this.$store.commit('ui/setHeaderPageTitle', 'checkout.thanks')
    this.$store.dispatch('cart/empty')
    this.$store.dispatch('checkout/empty')
    if (this.currentOrder && Object.keys(this.currentOrder).length <= 0) {
      this.$router.push({ name: 'home' })
    }
  },
  mounted () {
    global.$cookies.set('pickup-store-code', '')
  },
  destroyed () {
    this.$store.commit('orders/setOrder', {})
    this.$store.commit('user/newUser', false)
  },
  components: {
    MySingleOrder
  }
}
</script>
